export interface Product {
  id: string;
  name: string;
  category: string;
  categorySlug: string;
  price: number;
  unit: string;
  origin: string;
  description: string;
  features: string[];
  image: string;
  badge?: string;
  inSeason: boolean;
}

export const categories = [
  { name: '全部瓜果', slug: 'all' },
  { name: '西瓜', slug: 'watermelon' },
  { name: '哈密瓜', slug: 'hami-melon' },
  { name: '香瓜', slug: 'cantaloupe' },
  { name: '其他时令', slug: 'seasonal' },
];

export const products: Product[] = [
  {
    id: 'wm-001',
    name: '麒麟西瓜',
    category: '西瓜',
    categorySlug: 'watermelon',
    price: 39.9,
    unit: '个（约4-5斤）',
    origin: '山东潍坊',
    description: '皮薄肉脆，汁多味甜，瓜瓤鲜红诱人，每一口都是夏天的味道。采用有机种植，自然成熟，不使用催熟剂。',
    features: ['皮薄肉脆', '汁多味甜', '有机种植', '自然成熟'],
    image: 'https://readdy.ai/api/search-image?query=A%20whole%20ripe%20watermelon%20with%20dark%20green%20stripes%20on%20a%20clean%20light%20cream%20background%2C%20one%20slice%20cut%20open%20showing%20bright%20red%20flesh%20with%20black%20seeds%2C%20fresh%20and%20juicy%2C%20soft%20natural%20lighting%2C%20minimalist%20food%20photography%20style%20with%20warm%20tones%2C%20professional%20product%20shot%20on%20simple%20surface&width=800&height=800&seq=product-wm-001&orientation=squarish',
    badge: '热卖',
    inSeason: true,
  },
  {
    id: 'wm-002',
    name: '黑美人西瓜',
    category: '西瓜',
    categorySlug: 'watermelon',
    price: 45.9,
    unit: '个（约3-4斤）',
    origin: '广西南宁',
    description: '黑皮红瓤，甜度高达13度，肉质紧实爽脆，老少皆宜的消暑佳品。富含维生素和矿物质，健康美味。',
    features: ['黑皮红瓤', '甜度13度', '肉质紧实', '营养丰富'],
    image: 'https://readdy.ai/api/search-image?query=A%20whole%20dark%20green%20watermelon%20with%20smooth%20skin%20on%20a%20clean%20light%20cream%20background%2C%20sliced%20pieces%20showing%20deep%20red%20flesh%2C%20glistening%20juicy%20texture%2C%20minimalist%20food%20photography%20with%20warm%20natural%20light%2C%20professional%20studio%20product%20shot&width=800&height=800&seq=product-wm-002&orientation=squarish',
    badge: '新品',
    inSeason: true,
  },
  {
    id: 'hm-001',
    name: '西州蜜哈密瓜',
    category: '哈密瓜',
    categorySlug: 'hami-melon',
    price: 58.0,
    unit: '个（约3-4斤）',
    origin: '新疆哈密',
    description: '新疆直发，日照充足，瓜肉金黄细腻，香甜多汁。得天独厚的地理环境造就了西州蜜独特的蜜甜口感。',
    features: ['新疆直发', '日照充足', '瓜肉金黄', '蜜甜多汁'],
    image: 'https://readdy.ai/api/search-image?query=A%20whole%20golden%20hami%20melon%20with%20netted%20textured%20rind%20on%20a%20clean%20light%20cream%20background%2C%20cut%20slices%20showing%20bright%20orange%20flesh%2C%20minimalist%20food%20photography%20style%20with%20warm%20natural%20lighting%2C%20professional%20product%20shot%20on%20simple%20surface&width=800&height=800&seq=product-hm-001&orientation=squarish',
    badge: '爆款',
    inSeason: true,
  },
  {
    id: 'hm-002',
    name: '金黄哈密瓜',
    category: '哈密瓜',
    categorySlug: 'hami-melon',
    price: 52.0,
    unit: '个（约2.5-3.5斤）',
    origin: '甘肃敦煌',
    description: '金黄外皮，橙黄果肉，口感酥脆香甜。敦煌特有的沙质土壤和昼夜温差，孕育出独一无二的风味。',
    features: ['金黄外皮', '酥脆香甜', '沙质土壤', '昼夜温差大'],
    image: 'https://readdy.ai/api/search-image?query=A%20whole%20ripe%20yellow%20hami%20melon%20with%20smooth%20golden%20skin%20on%20a%20clean%20light%20cream%20background%2C%20cut%20open%20revealing%20bright%20orange%20juicy%20flesh%2C%20minimalist%20food%20photography%20with%20warm%20sunlight%20tones%2C%20professional%20product%20shot&width=800&height=800&seq=product-hm-002&orientation=squarish',
    inSeason: true,
  },
  {
    id: 'ct-001',
    name: '玉菇甜瓜',
    category: '香瓜',
    categorySlug: 'cantaloupe',
    price: 35.9,
    unit: '个（约1.5-2斤）',
    origin: '浙江嘉兴',
    description: '白玉般的瓜肉，清香扑鼻，入口即化。嘉兴水乡特有的温润气候，让玉菇甜瓜拥有独特的清甜滋味。',
    features: ['瓜肉如玉', '清香扑鼻', '入口即化', '水乡特产'],
    image: 'https://readdy.ai/api/search-image?query=A%20whole%20pale%20green%20cantaloupe%20melon%20with%20smooth%20skin%20on%20a%20clean%20light%20cream%20background%2C%20cut%20slices%20showing%20light%20green%20sweet%20flesh%2C%20minimalist%20food%20photography%20with%20soft%20natural%20light%2C%20professional%20studio%20product%20shot&width=800&height=800&seq=product-ct-001&orientation=squarish',
    badge: '时令',
    inSeason: true,
  },
  {
    id: 'ct-002',
    name: '绿宝石香瓜',
    category: '香瓜',
    categorySlug: 'cantaloupe',
    price: 32.9,
    unit: '个（约1-1.5斤）',
    origin: '河北保定',
    description: '翠绿如玉的外观，果肉细腻甘甜，香气浓郁。绿宝石香瓜以其独特的清甜和脆爽著称，是夏日解暑佳品。',
    features: ['翠绿如玉', '果肉细腻', '香气浓郁', '脆爽清甜'],
    image: 'https://readdy.ai/api/search-image?query=A%20whole%20green%20melon%20with%20smooth%20textured%20skin%20on%20a%20clean%20light%20cream%20background%2C%20cut%20pieces%20revealing%20translucent%20green%20flesh%2C%20minimalist%20food%20photography%20with%20warm%20lighting%2C%20professional%20product%20shot&width=800&height=800&seq=product-ct-002&orientation=squarish',
    inSeason: true,
  },
  {
    id: 'sl-001',
    name: '海南金煌芒',
    category: '其他时令',
    categorySlug: 'seasonal',
    price: 68.0,
    unit: '箱（约5斤）',
    origin: '海南三亚',
    description: '热带阳光孕育的金煌芒，果肉金黄饱满，香甜浓郁。三亚独特的热带气候让每一颗芒果都充满阳光的味道。',
    features: ['果肉金黄', '香甜浓郁', '热带阳光', '饱满多汁'],
    image: 'https://readdy.ai/api/search-image?query=Several%20ripe%20golden%20mangoes%20on%20a%20clean%20light%20cream%20background%2C%20one%20cut%20open%20showing%20bright%20yellow%20flesh%2C%20minimalist%20food%20photography%20with%20warm%20natural%20lighting%2C%20professional%20studio%20product%20shot&width=800&height=800&seq=product-sl-001&orientation=squarish',
    badge: '新季',
    inSeason: true,
  },
  {
    id: 'sl-002',
    name: '陕西水蜜桃',
    category: '其他时令',
    categorySlug: 'seasonal',
    price: 49.9,
    unit: '箱（约3斤）',
    origin: '陕西渭南',
    description: '粉嫩多汁的水蜜桃，皮薄肉厚，一口咬下满嘴蜜汁。陕西黄土高原的独特土壤赋予桃子无与伦比的香甜。',
    features: ['皮薄肉厚', '粉嫩多汁', '黄土高原', '蜜汁满溢'],
    image: 'https://readdy.ai/api/search-image?query=Several%20ripe%20pink%20peaches%20on%20a%20clean%20light%20cream%20background%2C%20one%20cut%20open%20showing%20juicy%20flesh%2C%20minimalist%20food%20photography%20with%20warm%20lighting%2C%20professional%20studio%20product%20shot&width=800&height=800&seq=product-sl-002&orientation=squarish',
    badge: '限量',
    inSeason: true,
  },
];

export function getProductsByCategory(slug: string): Product[] {
  if (slug === 'all') return products;
  return products.filter((p) => p.categorySlug === slug);
}

export function getProductById(id: string): Product | undefined {
  return products.find((p) => p.id === id);
}